var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTicketFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0651855,
    width: 24,
    height: 24,
    fill: "url(#pattern0_1508_166)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1508_166",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1508_166",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1508_166",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADpUlEQVR4nO2cv4tVVxDHLxGSKGlMTBGy6Jt5uyrbGLBZ4r6Zt1GiTbpsKgs1YBUVK43umwEb/QMkwdKksjBNOoOCYNxIBA1i449EmxQpAkEDQWWvnLeiqXTv23d3znW/H/i2y5kPc+fed/aeWxQAAAAAAAAAAPLng82+ap36Ry3xL0jsKIt9z2pXSP0vEnvM4vdI7NuxSefotebP9PSKJKqtvoPFDrD4Nyz2E6vdZ7U5Vi9fHfuX1KajS8mC0cmv3+dubwuJ7yH1E6T+A6ndJPH/Fibz5SH1R+2Of1wsB0YmDq5sTc1sIvXPSfwIqZ1m8V9Y/e9hyHylbLFfi9cHf2Nt5yi1ur3tbbV9rH6S1c+lebnwS72+tKZmNhRNYuPWw++lS5HVdrPYcVI7S2I3hnWp19bV6juL3Bgf9zfTjYik9xmLHSK1U/M3Iv8zWtjg48OPhQldO3l4NatPtsX3phsRi/1IandZ/Em0mOHHztQusz3V25wec1J3svh3JH6VxR/GF+9LF/HrtYoGAAAAABgu69Tf7u9yqV1Zdo9u+tLHuof9fRXx/aM79r21KMmj6iOs9lt4UZp5xK8nV4N3MiSXlWQP0tnz4yKDbtHmJO0uVhedZnIGi+cmRWy2smgSexC+cG1WkrMBOjp+4dzAQLRCdBndhehojReH0aHxUjGjFaLL6I5DR2u8JIwOjReIGa15BT9YFKLLZd3RpPZz9KK5YSHxS5VFz8v2bf1XuTIogjMOid/hbm9rsdi3PEn9cnQxnHEXj0z4u8UwSH+IxG5HF8WZhdRvpXcQi2HSVu/m8OI3ZxObI+l1ijog9QvxBXouOVeL5L5o8T0ZFFhmkl21iU7nNTIosMwiMjNW64HH8AI1j6QTYbWJHld/J7pAziSp6WoTjdHhSzM6qGNfRncSZxPbXZtoVrsYX6BnEVI7X4vktvSmoovjrGJzrW5Phyq5v9+RNk7Ci/OskrYlhrbPsV59zbOD7OGFcY4Rm02NuCjJ6aA7i/0RXoxmn99bHf90IMnYGvXKwpOzyqIz6JKyiYFohegyugvR0RovDqND46ViRitEl9Edh47WeEkYHRovEDNa8wp+sChEl8u6o3FE2StLJrV/BhgdOHTPS3HoPn1ZJfoy5IaF1L+qLDp95CN97CN68dyUiF1L316tLPr5p34gu1yI5LFPjnw4kOT/d3b/u81is7hB+osxIfYg/UcljYuBOxkAAAAAAAAAAACgaCZPAesXG0QelbQqAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketFill);
export default __webpack_public_path__ + "static/media/ticket-fill.60bdd0c79a72ced9ebf65df162ef1a7b.svg";
export { ForwardRef as ReactComponent };